<template>
  <component :is="activeComponent[accountType]" />
</template>

<script>
import { mapState } from 'vuex';
import * as ACCOUNT from '@/constants/accounts';

const Profile = () => import('./Profile');

export default {
  name: 'AccountBattle',
  computed: {
    ...mapState('current', ['accountType']),

    activeComponent() {
      return {
        [ACCOUNT.PROFILE]: Profile,
        [ACCOUNT.CLAN]: Profile,
        [ACCOUNT.TOURNAMENT]: Profile,
      };
    },
  },
};
</script>
